import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'anf-core-react';

/**
 * PaymentStatusBanner - Displays error or success banners for WSS payment flow
 */
function PaymentStatusBanner({ message, type }) {
  if (!message || !message.value) {
    return null;
  }

  if (type === 'error') {
    return (
      <div className="wss-payment-status-banner">
        <ErrorMessage id={`wss-payment-${type}-message`}>
          {message.value}
        </ErrorMessage>
      </div>
    );
  }

  return (
    <div className="wss-payment-status-banner">
      <div
        className={`wss-banner-message wss-banner-${type}`}
        role="status"
        aria-live="polite"
      >
        {message.value}
      </div>
    </div>
  );
}

PaymentStatusBanner.propTypes = {
  message: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  type: PropTypes.oneOf(['error', 'success']),
};

PaymentStatusBanner.defaultProps = {
  message: null,
  type: 'error',
};

export default PaymentStatusBanner;
